

























































































































































































import { Vue, Component } from "vue-property-decorator";

import moment from "moment";
import TestDetails, { TestDetail } from "./TrialPitInput/TestDetails.vue";

import ListableItemWrapper from "./ListableItemWrapper.vue";

import TrialPitLayer from "./TrialPitInput/TrialPitLayer.vue";
import {
  LeftSideLayer,
  RightSideLayer,
  LayerMaterials
} from "../types/TrialPitLayers";

import TrialPitDrawing from "./TrialPitDrawing.vue";

import PitDetails, { PitDetailModel } from "./TrialPitInput/PitDetails.vue";
import TrialPitFeature, {
  TrialPitFeatureModel
} from "./TrialPitInput/TrialPitFeature.vue";

import TrialPitTest, {
  TrialPitTestModel
} from "./TrialPitInput/TrialPitTest.vue";

@Component({
  components: {
    TestDetails,
    TrialPitDrawing,
    PitDetails,
    TrialPitFeature,
    ListableItemWrapper,
    TrialPitLayer,
    TrialPitTest
  }
})
export default class TrialPitInputForm extends Vue {
  private openPanels: number[] = [6];

  private testDetails: TestDetail = {
    testId: "0",
    testDate: moment(),
    testTime: moment(),
    testWeather: "Dry",
    testExcavationMethod: "Hand Tools"
  };

  private pitDetail: PitDetailModel = {
    width: 0,
    height: 0,
    depth: 0,
    groundLevel: 0,
    groundLevelLabel: "GROUND LEVEL",
    aboveGroundMaterial: "brick",
    strataBelowRef: "Bore Hole"
  };

  private leftLayers: LeftSideLayer[] = [];
  private rightLayers: RightSideLayer[] = [];

  private features: TrialPitFeatureModel[] = [];

  private tests: TrialPitTestModel[] = [];

  private redrawRequired: boolean = false;

  public getTrialPitImage() {
    return (this.$refs.trialPitDrawing as TrialPitDrawing).getImageFromCanvas();
  }

  public getTrialPit() {
    // mobile team getting different date format in IOS and android device
    // map date format from moment to string
    (this.testDetails.testDate as any) = moment(this.testDetails.testDate).toISOString();
    (this.testDetails.testTime as any) = moment(this.testDetails.testTime).toISOString();
    return {
      testDetails: this.testDetails,
      pitDetail: this.pitDetail,
      leftLayers: this.leftLayers,
      rightLayers: this.rightLayers,
      features: this.features,
      tests: this.tests
    };
  }

  public loadTrialPitFromJson(jsonInput: string) {
    const {
      testDetails,
      pitDetail,
      leftLayers,
      rightLayers,
      features,
      tests
    } = JSON.parse(jsonInput);

    // convert date format from string to moment
    testDetails.testDate = moment(testDetails.testDate);
    testDetails.testTime = moment(testDetails.testTime);

    this.$set(this, "testDetails", testDetails);
    this.$set(this, "pitDetail", pitDetail);
    this.$set(this, "leftLayers", leftLayers);
    this.$set(this, "rightLayers", rightLayers);
    this.$set(this, "features", features);
    this.$set(this, "tests", tests);

    this.redrawRequired = true;
  }

  private newLayerTemplate = () => ({
    topStep: 0,
    bottomStep: 0,
    layerDepth: 0,
    layerType: "brick",
    edgeType: "straight",
    layerDivider: "dotted",
    horizontalMeasurement: "none",
    verticalMeasurement: "show",
    rootsObserved: "None"
  })

  private newFeatureTemplate = () => ({
    type: "object",
    label: "",
    alignment: "center",
    orientation: 0,
    position: "parallel",
    shape: "circle",
    y1: 0,
    y2: 0,
    x1: 0,
    x2: 0,
    depth: 0,
    width: 0,
    height: 0
  })

  private newTestTemplate = () => {
    return {
      testType: "dv",
      distanceFromWall: 140,
      depthOfSample: 0,
      testResults: ""
    };
  }

  private removeItem(items: unknown[], index: number) {
    items.splice(index, 1);
    this.redrawRequired = true;
  }

  private handleLayerChanged() {
    this.redrawRequired = true;
  }

  private getCurrentDepth(layers: Array<{ layerDepth: number }>) {
    return (
      layers.reduce(
        (p: number, c) => (c.layerDepth ? p + c.layerDepth : p + 0),
        0
      ) + this.pitDetail.groundLevel
    );
  }

  private defaultTestDepth(test: TrialPitTestModel) {
    test.depthOfSample = this.getCurrentDepth(this.leftLayers) + 60;
    return test;
  }
}
